import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const ShortLinkCreate = lazy(() => import("../pages/short-link-create"));
const ShortLinkDetails = lazy(() => import("../pages/short-link-details"));
const ShortLinkListing = lazy(() => import("../pages/short-link-listing"));

export const ShortLinkRouter = [
  {
    path: "/short-link",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ShortLinkCreate />
          </Suspense>
        ),
      },
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ShortLinkListing />
          </Suspense>
        ),
      },
      {
        path: "details/:url_key",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ShortLinkDetails />
          </Suspense>
        ),
      },
    ],
  },
];
